<template>
  <div class="wrap-dashboard">
    <headView :option="title" :subtitleOpt="subtitleOpt">
      <headButton v-if="buttonOptions.btnAction" :option="buttonOptions"></headButton>
    </headView>
    <div class="panel-dashboard">
      <div class="wrapper-select">
        <section class="panel-dashboard__select-control">
          <h4 class="title-section">Filtros de estado general</h4>
          <div class="select-group">
            <b-select placeholder="Todos-Edificios" class="select-group__item input-select-custom"
              v-model="dataEdificio" @input="dashEdificio(dataEdificio)">
              <option value>Todos-Edificios</option>
              <option v-for="option in edificios" :value="option.id" :key="option.id">{{ option.name }}</option>
            </b-select>
            <b-select placeholder="Todos-Puntos de Control" class="select-group__item input-select-custom"
              v-model="dataCheckPoint" @input="dashCP(dataCheckPoint)">
              <option value>Todos-Puntos de Control</option>
              <option v-for="cp in cpByIdBuild(dataEdificio)" :value="cp.id" :key="cp.id">{{ cp.name }}</option>
            </b-select>
            <b-select placeholder="Estados-Fuera de rango o error" class="select-group__item input-select-custom"
              v-model="dataEstado" @input="dashState(dataEstado)">
              <option v-for="(option, index) in estado" :value="option.value" :key="index">{{ option.opc }}</option>
            </b-select>
          </div>
        </section>
        <!-- <section
          class="panel-dashboard__view_chart"
        >
          <h4 class="title-section">Tareas ejecutadas vs programadas</h4>
          <div id="myChartDashboard" class="chart" ref="dashboard"></div>
        </section> -->
        <section class="panel-dashboard__view-state" v-if="getDashInfo.generalstatus">
          <div class="content-slideShow content-slideShow--progress">
            <h4 class="title-section">Estado General</h4>
            <progress-bar ancho="50px" :progreso="getDashInfo.generalstatus" />
          </div>
        </section>
        <section class="panel-dashboard__content-checkPoint">
          <div class="table-section">
            <b-table class="table-history" :data="dataTable ? dataTable : []" default-sort-direction="asc"
              @click="row => toDetail(row)" style="cursor: pointer;">
              <template slot-scope="props">
                <b-table-column field="building" label="Edificio" width="400">{{
                  props.row.building
                }}</b-table-column>
                <b-table-column field="checkpoint" label="Punto de Control" width="400">{{
                  props.row.checkpoint
                }}</b-table-column>

                <b-table-column field="task" label="Tarea" width="400">{{
                  props.row.task
                }}</b-table-column>

                <!-- <b-table-column field="lastReport" label="Ultimo Reporte" width="400">
											{{ props.row.lastreport }}
                </b-table-column>-->
                <b-table-column field="report" label="Reporte" width="200" :style="[
                  ,
                  {
                    color: `${props.row.status == 'well' ||
                        props.row.status == 'range'
                        ? `#2ecc71`
                        : props.row.status == 'bad' ||
                          props.row.status == 'outrange'
                          ? `#ff5a5f`
                          : props.row.status == 'pending'
                            ? `#f5a623`
                            : `#808080`
                      }`
                  }
                ]" :title="props.row.report" class="report-table">
                  <div class="report">{{ props.row.report }}</div>
                </b-table-column>
              </template>

              <template slot="empty">
                <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                    </p>
                    <p>No hay datos.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import headButton from "../Componentes/headButton";
import progressBar from "../Componentes/progressBar";
import { mapGetters, mapState } from "vuex";
export default {
  name: "dashboard",
  components: {
    headView,
    headButton,
    progressBar
  },
  data() {
    return {
      title: {
        headText: "Dashboard",
        subtitle: ""
      },
      subtitleOpt: false,
      buttonOptions: {
        btnAction: false,
        valueBtn: "Descargar en Excel",
        ruta: "",
        btnType: "download"
      },
      dataEdificio: "",
      dataCheckPoint: "",
      dataEstado: "all",
      estado: [
        { value: "all", opc: "Todos los Estados" },
        { value: "well", opc: "Todo Conforme" },
        { value: "pending", opc: "Falta reportar" },
        { value: "outrange-bad", opc: "Fuera de Rango" },
        { value: "standby", opc: "Stand By" }
      ],
      progreso: 0,
      date: "",
      headers: [
        "lugar",
        "punto de control",
        "tarea",
        "ultimo reporte",
        "reporte"
      ],
      width: ["15%", "30%", "20%", "15%", "10%"],
      data: [],
      isLoading: true,
      myChart: null
    };
  },
  computed: {
    ...mapGetters(["edificios", "cpByIdBuild", "getDashInfo", "currentUser"]),
    dataTable() {
      if (this.getDashInfo.statistics) {
        this.data = this.getDashInfo.statistics.map(s => {
          let obj = {
            building: s.building.name,
            checkpoint: s.checkpoint.name,
            task: s.task.name,
            lastReport: s.time ? new Date(s.time).toLocaleString() : "",
            report:
              s.status == "pending"
                ? "FALTA"
                : s.status == "standby"
                  ? "STAND BY"
                  : `${s.answer}${this.unidad(
                    s.task.labeltype,
                    s.answer,
                    s.status
                  )}`,
            status: s.status,
            ids: {
              building: s.building.id,
              checkpoint: s.checkpoint.id,
              task: s.task.id
            }
          };
          return obj;
        });
      }
      return this.data;
      // return [];
    },
    isLoadingComp() {
      if (this.dataTable) {
        return false;
      }
      return true;
    }
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", "dashboard");
  },
  beforeDestroy() {
    this.$store.commit("resetColorChildren", "dashboard");
  },
  mounted() {
    // const test = this.getDashInfo;
  },
  created() {
    this.$store.commit("setColorChildren", "dashboard");
    this.$store.dispatch("GETUSERS");
    var d = new Date();
    d.setHours(0, 0, 0);
    this.date = d.toISOString();

    if (this.$localStorage.get("filtro")) {
      var obj = JSON.parse(this.$localStorage.get("filtro"));
      this.dataEdificio = obj.building;
      this.dataCheckPoint = obj.checkpoint;
      this.dataEstado = obj.status;
    } else {
      var obj = {
        date: this.date,
        building: this.dataEdificio,
        checkpoint: this.dataCheckPoint,
        status: this.dataEstado
      };
    }

    this.$store
      .dispatch("POSTDASHBOARD", {
        id_business: this.$store.getters.company_id,
        obj: obj,
        namespace: this.$store.state.namespace
      })
      .then(res => {
        // const options = {
        //   chart: {
        //     height: 300,
        //     type: "radialBar"
        //   },
        //   series: [
        //     this.getDashInfo.generalstatus.wellPercentage +
        //       this.getDashInfo.generalstatus.badPercentage +
        //       this.getDashInfo.generalstatus.standbyPercentage
        //   ],
        //   plotOptions: {
        //     radialBar: {
        //       startAngle: -135,
        //       endAngle: 135,
        //       track: {
        //         background: "#333",
        //         startAngle: -135,
        //         endAngle: 135
        //       },
        //       dataLabels: {
        //         name: {
        //           show: true
        //         },
        //         value: {
        //           show: true,
        //           formatter: value => {
        //             const numberValue = Math.round(
        //               (value * this.getDashInfo.generalstatus.totalTasks) / 100
        //             );
        //             return `${numberValue} de ${
        //               this.getDashInfo.generalstatus.totalTasks
        //             }`;
        //           }
        //         }
        //       }
        //     }
        //   },
        //   labels: ["Hecho"]
        // };
        // console.log(options);
        // this.myChart = new ApexCharts(this.$refs.dashboard, options);
        // this.myChart.render();
        this.$nextTick(() => {
          this.isLoading = false;
        })
      });
    this.buttonOptions.ruta = this.currentUser.reportDownloadLink;
  },
  methods: {
    dashEdificio(val) {
      var obj = {
        date: this.date,
        building: this.dataEdificio,
        checkpoint: this.dataCheckPoint,
        status: this.dataEstado
      };
      this.$store.dispatch("POSTDASHBOARD", {
        id_business: this.$store.getters.company_id,
        obj: obj,
        namespace: this.$store.state.namespace
      });
      this.$localStorage.set("filtro", JSON.stringify(obj));
    },
    dashCP(val) {
      var obj = {
        date: this.date,
        building: this.dataEdificio,
        checkpoint: this.dataCheckPoint,
        status: this.dataEstado
      };
      this.$store.dispatch("POSTDASHBOARD", {
        id_business: this.$store.getters.company_id,
        obj: obj,
        namespace: this.$store.state.namespace
      });
      this.$localStorage.set("filtro", JSON.stringify(obj));
    },
    dashState(val) {
      var obj = {
        date: this.date,
        building: this.dataEdificio,
        checkpoint: this.dataCheckPoint,
        status: this.dataEstado
      };
      this.$store.dispatch("POSTDASHBOARD", {
        id_business: this.$store.getters.company_id,
        obj: obj,
        namespace: this.$store.state.namespace
      });
      this.$localStorage.set("filtro", JSON.stringify(obj));
    },
    unidad(labeltype, answer, status) {
      let obs;
      switch (labeltype) {
        case "well-bad":
          if (answer === "") {
            obs = status === "well" ? "Bien" : "Mal";
          } else {
            obs = "";
          }
          break;
        case "pressure":
          obs = "PSI";
          break;
        case "number":
          obs = "";
          break;
        case "time":
          obs = " HORAS";
          break;
        case "farenheit":
          obs = "F";
          break;
        case "celcius":
          obs = "C";
          break;
        case "voltage":
          obs = "V";
          break;
        case "percentage":
          obs = "%";
          break;
      }
      return obs;
    },
    toDetail: function (row) {
      this.$store.dispatch("GETTASKS", row.ids.checkpoint);
      this.$router.push({
        name: "reporte",
        params: {
          id: `${row.ids.building}`,
          fk: `${row.ids.checkpoint}`,
          ts: `${row.ids.task}`
        }
      });
    }
  },
  watch: {
    "$store.state.namespace": function (n, o) {
      this.$store.dispatch("POSTDASHBOARD", {
        id_business: this.$store.getters.company_id,
        obj: {
          date: this.date,
          building: this.dataEdificio,
          checkpoint: this.dataCheckPoint,
          status: this.dataEstado
        },
        namespace: this.$store.state.namespace
      });
    }
  }
  // watch: {
  //   getDashInfo: function(n, o) {
  //     const options = {
  //       chart: {
  //         height: 300,
  //         type: "radialBar"
  //       },
  //       series: [
  //         n.generalstatus.wellPercentage +
  //           n.generalstatus.badPercentage +
  //           n.generalstatus.standbyPercentage
  //       ],
  //       plotOptions: {
  //         radialBar: {
  //           startAngle: -135,
  //           endAngle: 135,
  //           track: {
  //             background: "#333",
  //             startAngle: -135,
  //             endAngle: 135
  //           },
  //           dataLabels: {
  //             name: {
  //               show: true
  //             },
  //             value: {
  //               formatter: function(value) {
  //                 console.log(n, value);
  //                 const numberValue = Math.round(
  //                   (value * n.generalstatus.totalTasks) / 100
  //                 );
  //                 return `${numberValue} de ${n.generalstatus.totalTasks}`;
  //               }
  //             }
  //           }
  //         }
  //       },
  //       labels: ["Ejecutadas"]
  //     };
  //     this.myChart = new ApexCharts(document.querySelector("#myChartDashboard"), options);
  //     this.myChart.render();
  //   }
  // }
};
</script>

<style lang="scss">
@import "../../assets/styles/1.settings/index";
@import "../../assets/styles/2.tools/mixins/_mediaquerys";

.panel-dashboard {
  padding-top: 70px;
  // max-width: 1300px;
  width: 100%;

  .wrapper-select {
    padding: 0 30px;
    width: 100%;
  }

  &__view-state {
    margin: 15px 0;
    display: flex;
    justify-content: space-between;
  }

  &__content-checkPoint {
    display: flex;
    width: 100%;
    // flex-flow: wrap;
    flex-flow: row wrap;
  }
}

.select-group {
  // max-width: 1000px;
  display: flex;

  &__item {
    margin-right: 15px;

    &:last-child {
      margin-right: 1px;
    }
  }

  padding-bottom: 15px;
  border-bottom: 1px solid #dbdbdb;
}

.title-section {
  font-size: 25px;
  font-weight: bold;
  text-align: left;
  padding: 10px 0;
}

.content-slideShow {
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #d5d5d5;

  // box-shadow: 0 2px 1px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  &--progress {
    width: 100%;
  }

  &--report {
    width: 32%;
  }
}

.falta_repo_porcentaje {
  color: $colorReportNeutral;
  font-size: 45px;
  font-weight: bold;
  text-align: left;
  padding: 5px 0;
}

.content-datePicker {
  margin-right: 15px;
  width: 120%;
}

.data-picker-custom {
  .mx-input-wrapper {
    border-color: #dbdbdb;

    .mx-input {
      &::placeholder {
        color: #5e5e5e;
      }

      height: 3.2em;
      font-size: 15px;
      border-radius: 2px;
      border-color: #dbdbdb;
      box-shadow: 0px 3px 2px -3px rgba(0, 0, 0, 0.75);
    }

    .mx-input-append {
      right: 10px;
      padding: 4px;
    }
  }

  .mx-datepicker-popup {
    .mx-range-wrapper {
      .mx-calendar {
        min-height: 340px !important;
      }
    }
  }
}

.report {
  width: 100px !important;
  font-weight: bolder;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @include media-xl() {
    width: 250px !important;
  }
}

.table-section {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/dashboard.vue